import { format } from 'date-fns'
import { Log } from '@/types/logs'

import styles from './MechanicalInformationModal.module.scss'
import { BusAuthorizedStatus, UsedTranzauraValue } from '@/types/mechanicalInformation'

interface Props {
    log: Log
}

const TRANZAURA_LABEL_MAP = {
    [UsedTranzauraValue.No]: 'No',
    [UsedTranzauraValue.Yes]: 'Yes',
    [UsedTranzauraValue.NoDevice]: 'No device',
}

const BUS_AUTHORIZED_LABEL_MAP = {
    [BusAuthorizedStatus.BusAuthorized]: 'Yes, continue',
    [BusAuthorizedStatus.SubstitutionRequired]: 'No, substitute bus',
}

export const MechanicalInformationReadOnly = ({ log }: Props) => {
    const isBusAuthorized = log.mechanicalInfo?.busAuthorizedStatus === BusAuthorizedStatus.BusAuthorized

    return (
        <>
            <div className={styles.formItemsContainer}>
                <span className={styles.textBold}>Issue details</span>
                <div>
                    <span className={styles.label}>Has the driver used Transaura? </span>
                    <span className={styles.text}>
                        {log.mechanicalInfo?.tranzauraUsageType &&
                            (TRANZAURA_LABEL_MAP[log.mechanicalInfo.tranzauraUsageType] || '-')}
                    </span>
                </div>
                <div>
                    <p className={styles.label}>Time Engineering was contacted</p>
                    <p className={styles.text}>{log.mechanicalInfo?.timeEngineeringContactedDetails || '-'}</p>
                </div>
                <div>
                    <p className={styles.label}>Engineering statement</p>
                    <p className={styles.text}>{log.mechanicalInfo?.engineeringStatement || '-'}</p>
                </div>
            </div>
            <div className={styles.formItemsContainer}>
                <span className={styles.textBold}>Engineering solution</span>
                <div>
                    <span className={styles.label}>Has engineer authorized bus to continue? </span>
                    <span className={styles.text}>
                        {log.mechanicalInfo?.busAuthorizedStatus &&
                            (BUS_AUTHORIZED_LABEL_MAP[log.mechanicalInfo.busAuthorizedStatus] || '-')}
                    </span>
                </div>
                {isBusAuthorized && (
                    <div>
                        <span className={styles.label}>Time cleared </span>
                        <span className={styles.text}>
                            {log.mechanicalInfo?.timeCleared
                                ? format(new Date(log.mechanicalInfo?.timeCleared), 'HH:mm')
                                : '-'}
                        </span>
                    </div>
                )}
                {!isBusAuthorized && (
                    <div>
                        <div>
                            <span className={styles.label}>Subbed bonnet number </span>
                            <span className={styles.text}>{log.mechanicalInfo?.subbedBonnetNumber || '-'}</span>
                        </div>
                        <div>
                            <span className={styles.label}>Substitution time </span>
                            <span className={styles.text}>
                                {log.mechanicalInfo?.substitutionTime
                                    ? format(new Date(log.mechanicalInfo?.substitutionTime), 'HH:mm')
                                    : '-'}
                            </span>
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}
